fragment NutshellMarketingStartTriggerFragment on StartTrigger {
    id
    campaign {
        id
        name
        type
        ... on Campaign {
            status
            isStopOnGoal
            startTriggerDelayText
            editions(first: 1, archived: false) {
                totalCount
            }
            goal {
                id
                humanReadableTitle
            }
        }
        ... on SmsCampaign {
            status
            isStopOnGoal
            startTriggerDelayText
            editions(first: 1, archived: false) {
                totalCount
            }
            goal {
                id
                humanReadableTitle
            }
        }
    }
}
